import { redirectToLoginIfUnauthorized } from 'utils/sessionUnauthorized'
import { errorToast } from 'utils/toast'

function apiErrorPayload(err: unknown): {
  statusCode?: number
  message?: string | string[]
  error?: string
} | null {
  if (!err || typeof err !== 'object') {
    return null
  }

  const action = err as { payload?: unknown; response?: { data?: unknown } }
  const payload = action.payload ?? action.response?.data

  if (!payload || typeof payload !== 'object') {
    return null
  }

  return payload
}

export const handleApiErrors = (err: unknown, redirectToLogin = true) => {
  const payload = apiErrorPayload(err)

  if (!payload) {
    errorToast('Unknown server error')

    return
  }

  if (payload.statusCode === 401) {
    const message = Array.isArray(payload.message)
      ? payload.message[0]
      : payload.message

    errorToast(
      message
        ? `${payload.error ?? 'Unauthorized'} - ${message}`
        : 'Session expired. Please sign in again.'
    )
    if (redirectToLogin) {
      redirectToLoginIfUnauthorized(401)
    }

    return
  }

  const errorMessage = Array.isArray(payload.message)
    ? payload.message[0]
    : payload.message

  errorToast(errorMessage || 'Unknown server error')
}
